(function($, Drupal) {
  /**
   * Product search related functionalities
   */
  function productSearchFunctionalities() {
    var $first_facet_fi = $(".block-facet-blockfood-type"),
      $first_facet_title_fi = $("h2", $first_facet_fi),
      $first_facet_sv = $(".block-facet-blockfood-type-"),
      $first_facet_title_sv = $("h2", $first_facet_sv),
      $search_facet = $(".block-facets");

    // First facet is open by default
    $first_facet_fi.addClass("active-parent");
    $first_facet_title_fi.addClass("open");
    $first_facet_sv.addClass("active-parent");
    $first_facet_title_sv.addClass("open");

    // Add active-parent class to facet parents if a class has is-active class
    $search_facet.each(function() {
      var $emt = $(this);
      var $facet_link = $("a", $emt);
      if ($facet_link.hasClass("is-active")) {
        $emt.addClass("active-parent");
      }
    });

    // Toggle h2 open class, add/remove parent class based on the class
    $("h2", $search_facet).unbind('click').click(function(ev) {
      ev.preventDefault();
      $emt = $(this);
      $emt.toggleClass("open");
      if ($emt.hasClass("open")) {
        $emt.parent().addClass("active-parent");
      } else {
        $emt.parent().removeClass("active-parent");
      }
    });
  }

  /**
   * Form selecting functionality for the form region
   */
  function formSelect() {
    if ($("body").hasClass("page-node-type-page")) {
      if ($(".footer-form").hasClass("contact")) {
        $(".footer-form #contact-select").addClass("open");
        $(".footer-form .form-contact").addClass("open");

        $(".footer-form .form-guarantee").removeClass("open");
        $(".footer-form .form-faulty").removeClass("open");

        $(".footer-form #guarantee-select").removeClass("open");
        $(".footer-form #faulty-select").removeClass("open");
      }
      if ($(".footer-form").hasClass("tasteguarantee")) {
        $(".footer-form #guarantee-select").addClass("open");
        $(".footer-form .form-guarantee").addClass("open");

        $(".footer-form .form-contact").removeClass("open");
        $(".footer-form .form-faulty").removeClass("open");

        $(".footer-form #contact-select").removeClass("open");
        $(".footer-form #faulty-select").removeClass("open");
      }

      if ($(".footer-form").hasClass("reclamation")) {
        $(".footer-form #faulty-select").addClass("open");
        $(".footer-form .form-faulty").addClass("open");

        $(".footer-form .form-contact").removeClass("open");
        $(".footer-form .form-guarantee").removeClass("open");

        $(".footer-form #contact-select").removeClass("open");
        $(".footer-form #guarantee-select").removeClass("open");
      }
    }

    $(".footer-form #contact-select").click(function(ev) {
      ev.preventDefault();
      $emt = $(this);

      $emt.addClass("open");
      $(".footer-form .form-contact").addClass("open");

      $(".footer-form .form-guarantee").removeClass("open");
      $(".footer-form .form-faulty").removeClass("open");

      $(".footer-form #guarantee-select").removeClass("open");
      $(".footer-form #faulty-select").removeClass("open");
    });
    $(".footer-form #guarantee-select").click(function(ev) {
      ev.preventDefault();
      $emt = $(this);

      $emt.addClass("open");
      $(".footer-form .form-guarantee").addClass("open");

      $(".footer-form .form-contact").removeClass("open");
      $(".footer-form .form-faulty").removeClass("open");

      $(".footer-form #contact-select").removeClass("open");
      $(".footer-form #faulty-select").removeClass("open");
    });
    $(".footer-form #faulty-select").click(function(ev) {
      ev.preventDefault();
      $emt = $(this);

      $emt.addClass("open");
      $(".footer-form .form-faulty").addClass("open");

      $(".footer-form .form-contact").removeClass("open");
      $(".footer-form .form-guarantee").removeClass("open");

      $(".footer-form #contact-select").removeClass("open");
      $(".footer-form #guarantee-select").removeClass("open");
    });
  }

  Drupal.behaviors.primacat = {
    attach: function(context, settings) {
      $(window).on("load", function() {
        var breedHighlight = $(".view-display-id-block_breeds");

        breedHighlight.click(function(ev) {
          $(".view-content", breedHighlight).toggleClass("show");
          $(".view-header", breedHighlight).toggleClass("show");
        });

        // Product search
        productSearchFunctionalities();

        // Form region
        formSelect();
      });

      $("#block-primacat-primalanguageselector .current").on("click", function(e){
        var block = $("#block-primacat-primalanguageselector");
        block.toggleClass("language-list-open");
      });
    }
  };

})(jQuery, Drupal);
